import { gql } from "@apollo/client"

const GET_REPORT_PARENT_BOOKINGS_XLS_DOWNLOAD_LINK = gql`
  query ($event_id: ID!) {
    reportParentBookingsXls(event_id: $event_id) {
      filename
      type
      url
    }
  }
`

export { GET_REPORT_PARENT_BOOKINGS_XLS_DOWNLOAD_LINK }
